import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Video } from '../models/video.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  protocol = window.location.protocol
  host = window.location.host;
  currentUser = new BehaviorSubject<User>(null);
  sessionDetails = new BehaviorSubject<{
    [key: string]: any
  }>(null);
  codeSent$: BehaviorSubject<string> = new BehaviorSubject("");
  constructor(private http: HttpClient, private router: Router) {
  }

  isLoggedIn() {
    return this.currentUser.value !== null
  }

  login(route: string) {
    const user = JSON.parse(localStorage.getItem('user'))
    this.currentUser.next(user)
    decodeURIComponent(route);
    this.router.navigateByUrl(route)
  }

  logout() {
    localStorage.clear()
    this.currentUser.next(null)
    this.router.navigate(['./signin'])
  }

  getUser(login: string) {
    return this.http.get<User>(`api/users/?login=${login}`,)
  }

  checkLoginDetails(login: string, password: string) {
    return this.http.post<User>(`api/users/login`, { login: login, password: password })
  }

  nativLogin() {
    return this.http.get<{ [key: string]: any }>(`${this.protocol}//video.enativ.com/filterstatus`,
      { headers: { 'Content-Type': 'application/json' } })
  }

  shortNativLogin() {
    return this.http.get<{ [key: string]: any }>(`${this.protocol}//video.enativ.com/shortstatus`,
      { headers: { 'Content-Type': 'application/json' } })
  }

  public addSite(data: string, reqData: string, userName: string) {
    return this.http.get<any>(`${this.protocol}//www.enativ.com/api/add_site`,
      { headers: { 'Content-Type': 'application/json' }, params: { sites: data, username: userName, email: '', reqData: reqData } })
  }

  getUserVideos(type: string, userId: number) {//קבלת המועדפים של המשתמש
    const showBlocked = localStorage.getItem('showBlocked')
    return this.http.get<Video[]>(`api/users${type}/${userId}?showBlocked=${showBlocked}`)
  }

  public refreshNativ() {
    return this.http.get(`${this.protocol}//${this.host}/refresh`, { responseType: 'text' })
  }

  public deleteHistory() {
    const user = JSON.parse(localStorage.getItem('user'))
    return this.http.put<string>(`api/users/delete-history/${user.userId}`, { responseType: 'text' })
  }

  public getUserName(userId: number) {
    return this.http.get<any>(`${this.protocol}//api.enativ.com/apisite/GetUserDataByuid.aspx?userid=${userId}`)
  }

  public openProspect() {
    const user = JSON.parse(localStorage.getItem('user'))
    return this.http.post<any>(`api/users/open-prospect?userId=${user.userId}`, {})
  }

  public getUserMoreData() {
    const user = JSON.parse(localStorage.getItem('user'))
    return this.http.get<{ mainPhone: string, MobilePhone: string, WorkPhone: string, homephone: string }>(`api/users/get-user-more-details?userId=${user.userId}`, {})
  }

  public sendVerifyCode(type: any, reason: any, phoneNumber = "") {
    return this.http.get<{ res: any }>(`${this.protocol}//localhost:4200/api/send_verify_code`,
      {
        headers: { 'Content-Type': 'application/json' },
        params:
          { userId: JSON.parse(localStorage.getItem('user')).userId, type, reason, key: (new Date().getTime() * 167).toString(), phoneNumber }
      })
  }

  public updateVerifySendingAttempts(data: any) {
    this.http.post(`${this.protocol}//enativ.com/api/update_verify_sending_attempts`,
      JSON.stringify({ userId: JSON.parse(localStorage.getItem('user')).userId, userCode: data.userCode, sentCode: data.sentCode, isValid: data.isValid, times: data.times, reason: data.reason }), {
      headers: { 'Content-Type': 'application/json' }
    }).subscribe(
      data => {
        console.log('success updateVerifySendingAttempts', data)
      },
      error => {
        console.log('error updateVerifySendingAttempts', error)
      }
    );
  }

  public addYoutubeProfile(login: string, version: string) {
    return this.http.post(`api/users/add-youtube-profile?login=${login}&version=${version}`, {})
  }

  public saveCall(data: object) {
    return this.http.post<{ ID: number }>(`api/users/save-phone`, data)
  }

  public saveCall2(phoneId: number) {
    return this.http.post(`api/users/save-phone2?phoneId=${phoneId}`, {})
  }

  public updateAutoPlay(value:boolean) {
    const user = JSON.parse(localStorage.getItem('user'))
    user.autoPlay = value
    localStorage.setItem('user', JSON.stringify(user))
    return this.http.put(`api/users/update/autoPlay?userId=${user.userId}&value=${value}`, {})
  }

  public getUserType(userTypeId: string) {
    let userType: any = {}
    if (userTypeId.substring(userTypeId.length - 1, userTypeId.length) == "5") {
      userType['IS_USER_FR'] = true;
    }
    if (userTypeId.substring(userTypeId.length - 1, userTypeId.length) == "7") {
      userType.IS_USER_GUR = true;
    }
    if (userTypeId.substring(2, 3) == "2") {
      userType.USER_OPEN_ALL_SITES = true;
    }
    if (userTypeId.substring(userTypeId.length - 1, userTypeId.length) == "A") {
      userType.IS_USER_BOYAN = true;
    }
    if (userTypeId.charAt(5) == "7" || userTypeId.charAt(5) == "C") {
      userType.IS_USER_MAIL_ONLY = true;
    }
    if (userTypeId.charAt(5) == "4") {
      userType.IS_USER_PERSONAL = true;
    }
    return userType;
  }

  public getUserIp1() {
    return this.http.get<{ ip: string }>(`https://ipv4.myexternalip.com/json`,)
  }

  public getUserIp2() {
    return this.http.get<{ ip: string }>(`https://api.ipify.org/?format=json`,)
  }

  public checkIfEltaUser(ip:string) {
    return this.http.get<{ isElta: boolean }>(`api/users/check-if-elta?userIp=${ip}`)
  }

  public getDataInInitAspxPage() {
    return this.http.get(`https://enativ.com/init.aspx`, { responseType: 'text' })
  }

}
